import { useMemo } from 'react'

// TODO: Define Squad colors
export const useAssetColor = (id: string) => {
  return useMemo(() => {
    switch (id) {
      default:
        return 'yellow'
    }
  }, [id])
}
